import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { AuthenticatedResult } from 'angular-auth-oidc-client';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}
  public canActivate(): Observable<boolean> {
    return this.authService.isLoggedIn().pipe(
      map((isAuthorized: AuthenticatedResult) => {
        if (!isAuthorized.isAuthenticated) {
          this.router.navigate(['/unauthorized'], { replaceUrl: true });
          return false;
        }
        return true;
      })
    );
  }
}
